module.exports = __webpack_public_path__ + "img/text-security-disc.b7fa4dd1.svg";